<template>
  <div class="number-options">
    <div>
      <label :for="'minInput'" class="number-label">{{ $t('maintenance.number_config.min') }}</label>
      <input 
        id="minInput" 
        :placeholder="$t('maintenance.min')" 
        type="number" 
        name="text" 
        class="inputNumber"
        :class="{ 'is-invalid': hasMinError }"
        v-model.number="model.data.min"
        @input="validateNumberConfig"
      >
      <div v-if="hasMinError" class="invalid-feedback d-block">
        {{ minErrorMessage }}
      </div>
    </div>
    <div>
      <label :for="'maxInput'" class="number-label">{{ $t('maintenance.number_config.max') }}</label>
      <input 
        id="maxInput" 
        :placeholder="$t('maintenance.max')" 
        type="number" 
        name="text" 
        class="inputNumber"
        :class="{ 'is-invalid': hasMaxError }"
        v-model.number="model.data.max"
        @input="validateNumberConfig"
      >
      <div v-if="hasMaxError" class="invalid-feedback d-block">
        {{ maxErrorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
const TYPE = "number";
const MODEL = {
  data: {
    min: null,
    max: null,
  },
};

export default {
  props: {
    data: Object,
    config: Object,
  },
  data() {
    return {
      model: MODEL,
      minErrorMessage: "",
      maxErrorMessage: "",
    };
  },
  computed: {
    hasMinError() {
      return this.minErrorMessage !== "";
    },
    hasMaxError() {
      return this.maxErrorMessage !== "";
    },
    isValid() {
      return this.minErrorMessage === "" && this.maxErrorMessage === "";
    }
  },
  created() {
    const isDataEmpty = JSON.stringify(this.data.data) === "{}" || JSON.stringify(this.data.data) === "[]";
    const isDataArray = Array.isArray(this.data.data);
    const isNumberType = TYPE === this.config.type;
    const hasExistingData = this.data.data && typeof this.data.data === 'object' && !Array.isArray(this.data.data) && 
                            (this.data.data.min !== undefined || this.data.data.max !== undefined);
    
    if (isDataEmpty || isDataArray || !isNumberType || !hasExistingData) {
      this.model = JSON.parse(JSON.stringify(MODEL));
    } else {
      this.model = {
        data: {
          min: this.data.data.min !== undefined ? this.data.data.min : null,
          max: this.data.data.max !== undefined ? this.data.data.max : null,
        }
      };
    }
    
    this.validateNumberConfig();
  },
  methods: {
    validateNumberConfig() {
      this.minErrorMessage = "";
      this.maxErrorMessage = "";
      
      const minValue = this.model.data.min;
      const maxValue = this.model.data.max;
      
      const isMinEmpty = minValue === null || minValue === undefined || minValue === "";
      const isMaxEmpty = maxValue === null || maxValue === undefined || maxValue === "";
      
      if (!isMinEmpty && !isMaxEmpty) {
        if (Number(minValue) >= Number(maxValue)) {
          this.minErrorMessage = this.$t('maintenance.number_config.min_must_be_less_than_max') || "Minimum must be less than maximum";
          this.maxErrorMessage = this.$t('maintenance.number_config.max_must_be_greater_than_min') || "Maximum must be greater than minimum";
        }
      }
      
      this.$emit("validation-changed", this.isValid);
    },
    checkIfFieldsAreComplete() {
      const minValue = this.model.data.min;
      const maxValue = this.model.data.max;
      const isMinEmpty = minValue === null || minValue === undefined || minValue === "";
      const isMaxEmpty = maxValue === null || maxValue === undefined || maxValue === "";
      return !isMinEmpty && !isMaxEmpty && this.isValid;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.number-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  margin: auto;
}

.number-label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #1b3d5e;
}

.inputNumber {
  padding: .4rem;
  border-radius: 4px;
  border: .1rem solid #1b3d5e;
  outline: none;
  width: 100%;
}

.inputNumber.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
